import { createFileRoute } from '@tanstack/react-router'
import { useGoBack } from '@/hooks/use-go-back'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { AppUserForm } from '@/features/app-users/components/app-user-form'
import { useAppUserQuery } from '@/features/app-users/api/app-users.query'
import { useRequireAdmin } from '@/features/auth'
import { Spinner } from '@/components/ui/spinner'

export const Route = createFileRoute('/_authenticated/app-users/$appUserId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { appUserId } = Route.useParams()
  const goBack = useGoBack()
  const { canAccess, isLoading: isAuthLoading } = useRequireAdmin('/app-users/$appUserId', { appUserId })
  const { data: appUser, isLoading } = useAppUserQuery(appUserId, { include: "disciplines" })

  if (isAuthLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner className="size-8" />
      </div>
    )
  }
  if (!canAccess) return null

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4 p-4">
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/app-users/$appUserId', params: { appUserId } })}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h1 className="text-xl font-semibold">Modifica Utente</h1>
        </div>
        <div className="flex h-64 items-center justify-center rounded-lg border">
          <p className="text-muted-foreground">Caricamento...</p>
        </div>
      </div>
    )
  }

  if (!appUser) {
    return (
      <div className="flex flex-col gap-4 p-4">
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/app-users' })}>
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <h1 className="text-xl font-semibold">Modifica Utente</h1>
        </div>
        <div className="flex h-64 items-center justify-center rounded-lg border">
          <p className="text-muted-foreground">Utente non trovato</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" className="cursor-pointer" onClick={() => goBack({ to: '/app-users/$appUserId', params: { appUserId } })}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-xl font-semibold">Modifica Utente</h1>
      </div>
      <AppUserForm appUser={appUser} />
    </div>
  )
}
